module.exports = __webpack_public_path__ + "img/EXV_SD_Nav-Icon_Wein-Ausstellung.f242cda5.svg";